import { IAuthState, IUserProfile } from '@/@types'
import CONSTANTS from '@/constants'
import { readGuestUserProfile } from '@/helpers/guestUserStorage'

const buildDefaultUserProfile = (): IUserProfile => ({
  account_id: '',
  user_id: '',
  mfa_required: null,
  avatar: '',
  mfa_method: null,
  preferred_phone_number: null,
  email: '',
  first_name: '',
  last_name: '',
  recaptcha: '',
})

const persistedGuestProfile = readGuestUserProfile()
const initialUserProfile: IUserProfile = persistedGuestProfile
  ? { ...buildDefaultUserProfile(), ...persistedGuestProfile }
  : buildDefaultUserProfile()

const state: IAuthState = {
  isAuthenticated: false,
  userProfile: initialUserProfile,
  userLeadAlias: '',
  authProviders: CONSTANTS.AUTH_PROVIDERS,
  isTwoFactorRequired: false,
}

export default state
